// Per-page SEO metadata (title + description) for all 4 languages.
// Titles are kept short and brand-anchored. Descriptions ~150-160 chars.

export const SITE_URL = "https://kenosismethod.com";
export const SITE_NAME = "Kenosis Method";
export const DEFAULT_OG_IMAGE = "/generated/hero.png";

const en = {
  home: {
    title: "Kenosis Method — Less is Transformation",
    description: "A private, founder-led integrative method for health and alignment. Therapeutic bodywork, movement, inner practices and metabolic support for high-responsibility lives.",
  },
  philosophy: {
    title: "Philosophy — Kenosis Method",
    description: "Kenosis is a process of refinement: leaving the unessential behind so one's truest essence may emerge. Responsibility, alignment, authenticity.",
  },
  method: {
    title: "The Method — Kenosis Method",
    description: "A structured, personalized path aligning three dimensions: Structural Alignment, Inner Regulation and Metabolic Integration. Assessed and sequenced to one life.",
  },
  services: {
    title: "Services — Kenosis Method",
    description: "Complimentary Fit Call, Kenosis Assessment, Private In-Person Intensive, 12-Week Integration Program, Ongoing Private Concierge. Internationally available by application.",
  },
  founder: {
    title: "Founder — F. G. Aaron Giuga | Kenosis Method",
    description: "Founder & practitioner F. G. Aaron Giuga: medically trained massage therapist, advanced studies in Tuina/TCM, osteopathic and craniosacral work, yoga. Europe-based.",
  },
  journal: {
    title: "Journal — Kenosis Method",
    description: "Reflections and resources on refinement, alignment and integrative health: bodywork, breath, movement, nutrition and philosophy.",
  },
  apply: {
    title: "Request a Private Consultation — Kenosis Method",
    description: "Kenosis begins with an application, not a booking. Share your context; suitable applicants are invited to a complimentary fit call.",
  },
};

const de = {
  home: {
    title: "Kenosis Method — Weniger ist Transformation",
    description: "Eine private, gründergeführte integrative Methode für Gesundheit und Ausrichtung. Therapeutische Körperarbeit, Bewegung, innere Praktiken und metabolische Unterstützung.",
  },
  philosophy: {
    title: "Philosophie — Kenosis Method",
    description: "Kenosis ist ein Prozess der Verfeinerung: das Unwesentliche loslassen, damit das wahrste Wesen hervortreten kann. Verantwortung, Ausrichtung, Authentizität.",
  },
  method: {
    title: "Die Methode — Kenosis Method",
    description: "Ein strukturierter, personalisierter Weg über drei Dimensionen: Strukturelle Ausrichtung, Innere Regulation und Metabolische Integration. Auf ein Leben zugeschnitten.",
  },
  services: {
    title: "Leistungen — Kenosis Method",
    description: "Kennenlerngespräch, Kenosis Assessment, Präsenz-Intensiv, 12-Wochen-Integrationsprogramm, Private Concierge. International auf Anfrage verfügbar.",
  },
  founder: {
    title: "Gründer — F. G. Aaron Giuga | Kenosis Method",
    description: "Gründer & Praktiker F. G. Aaron Giuga: medizinisch ausgebildeter Massagetherapeut, TCM, osteopathische und craniosacrale Arbeit, Yoga. In Europa ansässig.",
  },
  journal: {
    title: "Journal — Kenosis Method",
    description: "Reflexionen und Ressourcen zu Verfeinerung, Ausrichtung und integrativer Gesundheit: Körperarbeit, Atem, Bewegung, Ernährung, Philosophie.",
  },
  apply: {
    title: "Private Beratung anfragen — Kenosis Method",
    description: "Kenosis beginnt mit einer Bewerbung, nicht mit einer Buchung. Geeignete Bewerber werden zu einem kostenlosen Gespräch eingeladen.",
  },
};

const it = {
  home: {
    title: "Kenosis Method — Il meno è trasformazione",
    description: "Un metodo integrativo privato guidato dal fondatore per salute e allineamento. Lavoro corporeo, movimento, pratiche interiori e supporto metabolico.",
  },
  philosophy: {
    title: "Filosofia — Kenosis Method",
    description: "Kenosis è un processo di raffinamento: lasciare indietro il non essenziale affinché l'essenza più vera emerga. Responsabilità, allineamento, autenticità.",
  },
  method: {
    title: "Il Metodo — Kenosis Method",
    description: "Un percorso strutturato e personalizzato attraverso tre dimensioni: Allineamento Strutturale, Regolazione Interiore, Integrazione Metabolica.",
  },
  services: {
    title: "Servizi — Kenosis Method",
    description: "Colloquio conoscitivo, Kenosis Assessment, Intensivo privato, Programma 12 settimane, Private Concierge. Disponibile a livello internazionale su richiesta.",
  },
  founder: {
    title: "Fondatore — F. G. Aaron Giuga | Kenosis Method",
    description: "Fondatore e praticante F. G. Aaron Giuga: massaggiatore con formazione medica, Tuina/MTC, lavoro osteopatico e craniosacrale, yoga. Con sede in Europa.",
  },
  journal: {
    title: "Journal — Kenosis Method",
    description: "Riflessioni e risorse su raffinamento, allineamento e salute integrativa: lavoro corporeo, respiro, movimento, nutrizione, filosofia.",
  },
  apply: {
    title: "Richiedi una consulenza privata — Kenosis Method",
    description: "Kenosis inizia con una candidatura, non con una prenotazione. I candidati idonei sono invitati a un colloquio gratuito.",
  },
};

const fr = {
  home: {
    title: "Kenosis Method — Le moins est transformation",
    description: "Une méthode intégrative privée, menée par son fondateur, pour la santé et l'alignement. Travail corporel, mouvement, pratiques intérieures et soutien métabolique.",
  },
  philosophy: {
    title: "Philosophie — Kenosis Method",
    description: "Kenosis est un processus de raffinement : laisser derrière soi le non-essentiel afin que l'essence la plus vraie émerge. Responsabilité, alignement, authenticité.",
  },
  method: {
    title: "La Méthode — Kenosis Method",
    description: "Un chemin structuré et personnalisé à travers trois dimensions : Alignement Structurel, Régulation Intérieure, Intégration Métabolique.",
  },
  services: {
    title: "Services — Kenosis Method",
    description: "Appel de compatibilité, Kenosis Assessment, Intensif en présentiel, Programme 12 semaines, Private Concierge. Disponible à l'international sur candidature.",
  },
  founder: {
    title: "Fondateur — F. G. Aaron Giuga | Kenosis Method",
    description: "Fondateur et praticien F. G. Aaron Giuga : massothérapeute de formation médicale, Tuina/MTC, ostéopathie et craniosacré, yoga. Basé en Europe.",
  },
  journal: {
    title: "Journal — Kenosis Method",
    description: "Réflexions et ressources sur le raffinement, l'alignement et la santé intégrative : travail corporel, souffle, mouvement, nutrition, philosophie.",
  },
  apply: {
    title: "Demander une consultation privée — Kenosis Method",
    description: "Kenosis commence par une candidature, non par une réservation. Les candidats retenus sont invités à un appel gratuit.",
  },
};

export const SEO = { en, de, it, fr };

// JSON-LD schemas — used site-wide on Home
export const buildJsonLd = () => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${SITE_URL}#organization`,
      name: "Kenosis Method",
      url: SITE_URL,
      logo: `${SITE_URL}/generated/hero.png`,
      description: "A private, founder-led integrative method for health and alignment.",
      founder: { "@id": `${SITE_URL}#founder` },
      areaServed: ["Europe"],
      slogan: "Less is Transformation",
    },
    {
      "@type": "HealthAndBeautyBusiness",
      "@id": `${SITE_URL}#business`,
      name: "Kenosis Method",
      url: SITE_URL,
      priceRange: "€€€€",
      description: "Private, founder-led integrative health and alignment concierge. Therapeutic bodywork, movement, inner practices and metabolic support.",
      areaServed: ["Europe", "International (by application)"],
      knowsAbout: [
        "Medical massage", "Manual therapy", "Osteopathy", "Craniosacral therapy",
        "Tuina", "Traditional Chinese Medicine", "Yoga", "Breathwork",
        "Nutrition", "Integrative health",
      ],
    },
    {
      "@type": "Person",
      "@id": `${SITE_URL}#founder`,
      name: "F. G. Aaron Giuga",
      jobTitle: "Founder & Practitioner, Kenosis Method",
      worksFor: { "@id": `${SITE_URL}#organization` },
      knowsLanguage: ["Italian", "German", "English", "French", "Portuguese", "Spanish"],
      description: "Medically trained massage therapist and integrative practitioner. Advanced studies in Tuina/TCM, osteopathic and craniosacral work, and yoga.",
      alumniOf: ["University of Amsterdam", "University of Trieste"],
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}#website`,
      url: SITE_URL,
      name: "Kenosis Method",
      inLanguage: ["en", "de", "it", "fr"],
      publisher: { "@id": `${SITE_URL}#organization` },
    },
  ],
});
